<template>
  <b-navbar type="light" variant="light" fixed="top" class="d-flex justify-content-between">
    <b-navbar-nav>
      <b-nav-item @click="onMenuButtonClick" class="d-block d-lg-none">
        <icool-icon icon="hamburger-menu" />
      </b-nav-item>
      <b-nav-item class="d-none d-lg-block" @click="homeBtnClicked">
        <icool-icon icon="home-lg" />
      </b-nav-item>
    </b-navbar-nav>
    <icool-status />
    <!-- Right aligned nav items -->
    <b-navbar-nav>
      <b-nav-item @click="showCloudStatusModal" class="d-none d-sm-block my-auto">
        <cloud-status />
        <cloud-status-modal ref="cloudStatusModal" />
      </b-nav-item>
      <settings-drop-down-menu />
    </b-navbar-nav>
  </b-navbar>
</template>  svg {width: 100%; height: auto;}

<script>
import { mapGetters } from 'vuex';
import SettingsDropDownMenu from '@/components/navigation/top-navigation/SettingsDropDownMenu.vue';
import CloudStatus from '@/components/navigation/top-navigation/CloudStatus.vue';
import CloudStatusModal from '@/components/navigation/top-navigation/CloudStatusModal.vue';
import eventBus from '@/components/utils/slideout-panel/eventBus';
import IcoolStatus from '@/components/navigation/IcoolStatus.vue';

export default {
  name: 'TopNavigation',
  computed: {
    ...mapGetters([
    ]),
  },
  methods: {
    onMenuButtonClick() {
      this.$emit('menu-button-clicked');
    },
    showCloudStatusModal() {
      this.$refs.cloudStatusModal.show();
    },
    homeBtnClicked() {
      eventBus.$emit('goToStartingScreen');
    },
  },
  components: {
    CloudStatusModal,
    CloudStatus,
    SettingsDropDownMenu,
    IcoolStatus,
  },
};
</script>

<style scoped>

</style>
